import React from 'react'
import Wadhead from './Wadhead/Wadhead'
import Wwo from './Wwo/Wwo'
import Wgbs from './Wgbs/Wgbs'
import Wcdw from './Wcdw/Wcdw'
import WhyHIreUs from './WhyHireUs/WhyHIreUs'

function ECommerceDevelopment() {

  
  return (
    <>
      <Wadhead/>
      <WhyHIreUs/>
      <Wwo />
      <Wgbs />
    </>
  )
}

export default ECommerceDevelopment
